import type { Struct } from 'superstruct';
import { mask } from 'superstruct';

export function workaround_softMask<T, S>(
	value: unknown,
	struct: Struct<T, S>
) {
	try {
		return mask(value, struct);
	} catch {
		return value as T;
	}
}
